import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import FilterMultiselect from '../filterMultiselect'

const sizeMap = {
  s: { details: '(2MP-6MP)' },
  m: { details: '(2MP-6MP)' },
  l: { details: '(6MP-12MP)' },
  xl: { details: '(12MP-20MP)' },
  xxl: { details: '(20MP+)' }
}

const FiltersSize = ({ locationParams, makeSearchLink, history, items }) => {
  const getFormattedOptions = options => {
    return options.map(option => {
      return {
        label: option.key.toUpperCase(),
        sublabel: (sizeMap[option.key] && sizeMap[option.key].details) || '',
        ...option
      }
    })
  }

  return (
    <FilterMultiselect
      type="sizes"
      items={getFormattedOptions(items)}
      locationParams={locationParams}
      makeSearchLink={makeSearchLink}
      history={history}
    />
  )
}

FiltersSize.propTypes = {
  locationParams: PropTypes.object.isRequired,
  makeSearchLink: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  items: PropTypes.array
}

export const FiltersSizeComponent = FiltersSize
export default withRouter(FiltersSize)
